module.exports = __webpack_public_path__ + "img/leona_5_ocular.e0eec404.jpg";